import { IonContent } from '@ionic/react';
import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { HARDCODED_CATEGORIES } from '@/pages/Onboarding/Layouts/OwnAI_Dominate/constants';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { ContentContainer, PageStyles } from './SummaryIntro.styles';

export const SummaryIntro: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Summary Intro',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const { refreshUser } = useAccount();

  const handleNextStep = () => {
    userService.createOrUpdate({
      categories: HARDCODED_CATEGORIES,
      onboarding_data: {
        first_categories: HARDCODED_CATEGORIES,
      },
    });
    refreshUser();
    wizard.nextStep();
  };

  return (
    <PageStyles background="domination">
      <IonContent>
        <ContentContainer>
          <Player
            src="/assets/layout-own-ai-dominate/summary_screens/summary_intro.json"
            autoplay
            loop={false}
            keepLastFrame
          />
          <OwnAiTitle className={'title'}>
            Impressive pick! Looks like you're ready for some serious dominant
            energy
          </OwnAiTitle>
        </ContentContainer>
      </IonContent>

      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'red-gradient'}
        buttonRadius={'sm'}
        buttonSize={'medium'}
      />
    </PageStyles>
  );
};
